import List from './list/LabResearchPolicyHolderRelationListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})